import React from 'react';
import { Typography, makeStyles, Theme, createStyles } from '@material-ui/core';
import Constants from '../types/constants';
import clsx from 'clsx';

const contentMaxWidth = Constants.PageEditCompanyContentMaxWidth;
const useStyles = makeStyles((theme: Theme) => createStyles({
    propdisproot: {
        display: 'flex',
        justifyContent: 'flex-start',
        paddingLeft: theme.spacing(2),
        minHeight: 24,
        '&:hover': {
            backgroundColor: theme.palette.grey[200],
            width: contentMaxWidth,
        }
    },
    withDivider: {
        borderTop: 'solid 1px #e0e0e0',
        width: contentMaxWidth,
    },
    propdisplabel: {
        flex: '0 0',
        width: 200,
        minWidth: 200,
    },
    propdispvalue: {
        flex: '1 1'
    },
    bold: {
        fontWeight: 600,
    }
}))

type PropertyDisplayProps = {
    label: string
    children?: React.ReactNode
    withDivider?: boolean,
    bold?: boolean,
    component?: string,
};

export const PropertyDisplay = (props: PropertyDisplayProps) => {
    const classes = useStyles();
    const variantMapping = { body1: props.component || 'p', body2: 'p'}
    return (<div className={clsx(classes.propdisproot, props.withDivider && classes.withDivider)}>
        <div className={classes.propdisplabel}><Typography variant='body2'>{props.label}</Typography></div>
        <div className={classes.propdispvalue}><Typography className={clsx(props.bold && classes.bold)} variantMapping={variantMapping}>{props.children}</Typography></div>
    </div>);
};
